import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DrugTestingHero,
  DrugTestingPageShell,
  SampleTypeChoices,
  useDrugTestingCopy
} from "@/components/site/drug-testing/DrugTestingShared";
import { SamplingLocationsSection } from "@/components/site/SamplingLocationsSection";
import { certificatePathFor } from "@/data/certificateSlugs";
import { privateDrugEnquiryHref } from "@/data/drugTesting";
import { PageMeta } from "@/components/site/PageMeta";

const DrogtestningForIntyg = () => {
  const { lang, copy } = useDrugTestingCopy();
  const f = copy.forIntyg;



  return (
    <DrugTestingPageShell breadcrumb={[{ label: f.label }]}>
      <PageMeta title={f.metaTitle} description={f.metaDescription} />
      <DrugTestingHero label={f.label} title={f.title}>
        <p>{f.subtitle}</p>
        <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:flex-wrap sm:items-center">
          <Button asChild variant="hero" size="xl" className="w-full sm:w-auto">
            <a href="#provtyper">
              {f.primaryCta}
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <Button asChild variant="ghost-outline" size="xl" className="w-full sm:w-auto">
            <Link to={privateDrugEnquiryHref(lang, "intyg")}>{f.secondaryCta}</Link>
          </Button>
        </div>
      </DrugTestingHero>

      <SampleTypeChoices purpose="intyg" />

      <section className="pb-14 lg:pb-16">
        <div className="container-wide grid gap-8 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              {f.distinguishTitle}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground">{f.distinguishText}</p>
            <h2 className="mt-10 font-display text-2xl font-semibold tracking-tight text-foreground">
              {f.transportTitle}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-muted-foreground">{f.transportText}</p>
            <Button asChild variant="ghost-outline" size="lg" className="mt-5">
              <Link to={certificatePathFor("droger-alkohol", lang)}>{f.transportCta}</Link>
            </Button>
          </div>
          <aside className="rounded-3xl border border-border/60 bg-card p-7 shadow-card h-fit">
            <h2 className="font-display text-xl font-semibold text-foreground">{f.tellTitle}</h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{f.tellText}</p>
            <Button asChild variant="hero" size="lg" className="mt-6 w-full">
              <Link to={privateDrugEnquiryHref(lang, "intyg")}>{f.tellCta}</Link>
            </Button>
          </aside>
        </div>
      </section>

      <SamplingLocationsSection className="bg-muted/20" />
    </DrugTestingPageShell>
  );
};

export default DrogtestningForIntyg;
